<template>
  <div id="container">
    <!-- 头部返回 -->
    <transition name="headMove" appear>
      <header>
        <span class="back"></span>
        <el-input v-model="Template.name" placeholder="请输入模板名称" class="h4"></el-input>
        <div class="handle">
          <button @click="getBack">返回</button>
          <button @click="preserve">立即保存</button>
        </div>
      </header>
    </transition>

    <!-- 内容 -->
    <div id="content">
      <left></left>
      <center></center>
      <right></right>
    </div>
  </div>
</template>

<script>
import {
  TemplateParticularList,
  addFitmentTemplate,
  alterFitmentTemplate,
  alterFitmentTemplateRename,
} from "@/api/serviceCenter/DecorationInfoController";
import left from "./components/left/index";
import center from "./components/center/index";
import right from "./components/right/index";
import { mapState, mapMutations } from "vuex";
import { queryActivity } from "@/api/activityController";
import { exchangeActivityList, taskList } from "@/api/paradiseAndTaskCommonController";
import { querySellerCouponWriteList } from "@/api/integralCenter/couponWriteController";
export default {
  computed: {
    ...mapState(["pageConfig"]),
  },
  components: {
    left,
    center,
    right,
  },
  data() {
    return {
      id: "",
      Template: {
        detailInfo: "",
        name: "",
      },
      modificationTemplate: {
        detailInfo: "",
        id: "",
        name: "",
      },
    };
  },
  mounted() {
    this.id = this.$route.query.id || 2;
    this.modificationTemplate.id = this.$route.query.id;
    if (this.id == 2) {
      this.$store.commit("setDetail", this.$store.state.pageConfigtwo);
      this.$store.commit("switchPages", 1);
    } else {
      this.TemplateParticularList();
      return;
    }
    this.fairylandlist();
    this.taskList();
    this.getSellerCouponWriteList();
    this.gitmaterialist();
    this.gitdiscountllist();
    this.getHotAtivety();
  },
  methods: {
    ...mapMutations(["componentListChangeTurnOn"]),
    getBack() {
      this.$router.push("/integralCenter/shopDecoration");
      this.componentListChangeTurnOn();
    },
    // 获取模板信息详情
    async TemplateParticularList() {
      TemplateParticularList(this.id).then((res) => {
        this.Template.name = res.data.name;
        // this.$store.state.pageConfig = JSON.parse(res.data.detailInfo);
        // console.log(JSON.parse(res.data.detailInfo));
        this.$store.commit("setDetail", JSON.parse(res.data.detailInfo));
        this.$store.commit("switchPowerItem", 0);
        console.log("detailInfo", JSON.parse(res.data.detailInfo));
        // 新实时数据
        this.taskList("edit"); //积分任务
        this.getSellerCouponWriteList("edit"); //兑换精品
        this.fairylandlist("integralParadise"); //积分乐园
        // Note:热门互动
        this.getHotAtivety();
        // Note:积分商城
        this.gitmaterialist();
        this.gitdiscountllist();
      });
    },
    // 点击保存按钮
    preserve() {
      if (this.id == 2) {
        //没ID 就是创建模板
        this.Template.detailInfo = JSON.stringify(this.pageConfig);
        addFitmentTemplate(this.Template).then((res) => {
          this.$message({
            message: "模板创建成功！",
            type: "success",
          });
          this.$router.push("/integralCenter/shopDecoration");
        });
      } else {
        // 修改当前id的模板
        this.modificationTemplate.detailInfo = JSON.stringify(this.pageConfig);
        this.modificationTemplate.name = this.Template.name;
        alterFitmentTemplate(this.modificationTemplate).then((res) => {
          this.$message({
            message: "模板修改成功！",
            type: "success",
          });
          this.$router.push("/integralCenter/shopDecoration");
        });
      }
    },
    //积分乐园列表
    fairylandlist(type) {
      let form = {
        current: 1, //页码 ,
        size: 100, //分页数量
        mainType: 2, //活动主类型(不传代表全部) 1：积分任务 2：积分乐园 ,
        // status: 2, //活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束
        status: 4, //活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束 4:待上架或已上架
      };
      queryActivity(form).then((res) => {
        let newList = res.data.records;
        console.log(newList);
        res.data.records.forEach((item) => {
          console.log(item);
          item.visibility = true;
          item.imageUrl = require("@/assets/images/icon_dzpcj.png");
          item.desc = "转出好运";
          if (item.status == 3) {
            res.data.records.splice(index, 1);
          }
        });
        //积分乐园编辑操作,做数据实时更新
        if (type == "edit") {
          //获取模板数据列表
          let integral = this.$store.state.pageConfig.integralPlay.playList;
          let newIntegral = this.upListData(integral, newList);
          // 新数据替换模板旧数据
          this.$store.state.pageConfig.integralPlay.playList = newIntegral;
          return;
        }
        this.$store.state.pageConfig.integralPlay.playList = res.data.records;
      });
    },
    // 积分任务列表
    taskList(type) {
      let form = {
        current: 1, //页码 ,
        size: 100, //分页数量
        mainType: 1, //活动主类型(不传代表全部) 1：积分任务 2：积分乐园 ,
        status: 4, //活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束 4:待上架或已上架
      };
      // 实时的积分任务列表
      queryActivity(form).then((res) => {
        let listArray = res.data.records;
        listArray.forEach((item, index) => {
          item.visibility = true;
          if (item.activityType == 1) {
            item.desc = "连续签到";
            item.imageUrl = require("@/assets/images/icon_lxqd.png");
          }
          if (item.activityType == 2) {
            item.desc = "浏览礼品有礼";
            item.imageUrl = require("@/assets/images/hot_rlqd.png");
          }
          if (item.activityType == 3) {
            item.desc = "每日抢好礼";
            item.imageUrl = require("@/assets/images/icon_mrqhl.png");
          }
          if (item.activityType == 4) {
            item.desc = "关注店铺";
            item.imageUrl = require("@/assets/images/icon_gzdp.png");
          }
          if (item.activityType == 5) {
            item.desc = "邀请开卡";
            item.imageUrl = require("@/assets/images/icon_yqkk.png");
          }
          if (item.activityType == 6) {
            item.desc = "邀请关注店铺";
            item.imageUrl = require("@/assets/images/icon_yqgzdp.png");
          }
          if (item.activityType == 7) {
            item.desc = "完善信息有礼";
            item.imageUrl = require("@/assets/images/hot_wsxx.png");
          }
        });
        // this.$store.state.pageConfig.integralTask.activityList = listArray;
        // 编辑操作
        if (type == "edit") {
          // 模板列表数据
          let integralTask = this.$store.state.pageConfig.integralTask.activityList;
          console.log(integralTask, listArray);
          let arrNew = this.upListData(integralTask, listArray);
          console.log(arrNew);
          // 新数据替换模板旧数据
          this.$store.state.pageConfig.integralTask.activityList = arrNew;
          return;
        }

        this.$store.state.pageConfig.integralTask.activityList = listArray;
      });
    },
    // 首页 --兑换精选
    getSellerCouponWriteList(type) {
      let str = {
        current: 1,
        size: 50,
      };
      exchangeActivityList(str).then((res) => {
        res.data.records.forEach((item, index) => {
          item.visibility = true;
          if (item.activityType == 9) {
            item.imageUrl = require("@/assets/images/icon_coupon.png");
          }
          if (item.activityType == 10) {
            item.imageUrl = require("@/assets/images/btn_power1_n.png");
          }
        });
        if (type == "edit") {
          let exchangeList = this.$store.state.pageConfig.menberPage.exchangeList;
          let arrNew = this.upListData(exchangeList, res.data.records);
          console.log("arrNew", arrNew);
          // 新数据替换模板旧数据
          this.$store.state.pageConfig.menberPage.exchangeList = arrNew;
          return;
        }
        this.$store.state.pageConfig.menberPage.exchangeList = res.data.records.filter((item) => item.status != 3);
      });
    },

    // 新旧数据对比更新
    upListData(oldData, newData) {
      let newList = [];
      console.log("oldData", oldData);
      console.log("newData", newData);
      if (oldData.lenght == 0) {
        newData.forEach((item) => {
          if (item.status != 3) {
            newList.push(item);
          }
        });
      } else {
        let idArr = oldData.map((i) => i.id);
        newData.forEach((item) => {
          if (idArr.indexOf(item.id) == -1) {
            // // 新活动做默认隐藏
            // item.visibility = false;
            // Note:新活动要求显示
            item.visibility = true;
            // 过滤已结束活动
            if (item.status != 3) {
              newList.push(item);
            }
          } else {
            oldData.map((i) => {
              if (i.id == item.id) {
                // 活动状态替换
                i.status = item.status;
                // 活动名替换
                i.activityName = item.activityName;
              }
            });
          }
        });
      }
      let arrNew = [...newList, ...oldData];
      arrNew = arrNew.filter((item) => {
        return item.status != 3;
      });
      return arrNew;
    },
    // 积分商城 --兑换实物
    gitmaterialist() {
      let discount = {
        activityType: 9,
        current: 1,
        size: 100,
        status: 4, //活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束 4:待上架或已上架
      };
      exchangeActivityList(discount).then((res) => {
        res.data.records.forEach((item, index) => {
          item.visibility = true;
          item.imageUrl = require("@/assets/images/icon_dzpcj.png");
        });

        this.$store.state.pageConfig.integralShop.actualList = res.data.records;
      });
    },
    // 积分商城 --兑换优惠券
    gitdiscountllist() {
      let material = {
        activityType: 10, // 10：积分兑换优惠券 ,
        current: 1,
        size: 100,
        status: 4, //活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束 4:待上架或已上架
      };
      exchangeActivityList(material).then((res) => {
        res.data.records.forEach((item, index) => {
          item.visibility = true;
          item.imageUrl = require("@/assets/images/icon_coupon.png");
        });
        this.$store.state.pageConfig.integralShop.couponList = res.data.records;
      });
    },
    // 热门互动
    getHotAtivety() {
      let form = {
        current: 1,
        // mainType: '1,2,3', //活动主类型(不传代表全部) 1：积分任务 2：积分乐园 ,
        size: 100,
        status: 4, // 活动状态 (不传代表查询全部) 1:未开始 2:进行中 3:已结束 4:未开始或进行中
      };
      taskList(form).then((res) => {
        res.data.records.forEach((item, index) => {
          item.visibility = true;
          if (item.activityType == 1) {
            item.desc = "天天爱签到";
            item.imageUrl = require("@/assets/images/icon_lxqd.png");
          }
          if (item.activityType == 2) {
            item.desc = "浏览礼品有礼";
            item.imageUrl = require("@/assets/images/hot_rlqd.png");
          }
          if (item.activityType == 3) {
            item.desc = "天天抢好礼";
            item.imageUrl = require("@/assets/images/icon_mrqhl.png");
          }
          if (item.activityType == 4) {
            item.desc = "天天爱关注";
            item.imageUrl = require("@/assets/images/icon_gzdp.png");
          }
          if (item.activityType == 5) {
            item.desc = "天天爱邀请开卡";
            item.imageUrl = require("@/assets/images/icon_yqkk.png");
          }
          if (item.activityType == 6) {
            item.desc = "天天邀请关注店铺";
            item.imageUrl = require("@/assets/images/icon_yqgzdp.png");
          }
          if (item.activityType == 7) {
            item.desc = "完善信息有礼";
            item.imageUrl = require("@/assets/images/hot_wsxx.png");
          }
          if (item.activityType == 8) {
            item.desc = "天天爱转盘";
            item.imageUrl = require("@/assets/images/icon_dzpcj.png");
          }
        });
        let list = res.data.records;
        console.log(list, 22222);
        this.$store.state.pageConfig.menberPage.hotList = list;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#container {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1111;
  width: 100%;
  height: 100%;
  background-color: #f5f7fa;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    background-color: #fff;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 3px;
  }
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 28px;
    height: 60px;
    background-color: #464c5b;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.06);
    .back {
      width: 50px;
      color: #fff;
      font-size: 14px;
      cursor: default;
    }
    /deep/ .h4 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 366px;
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 19px;
      color: #fff;
      border: 1px solid #464c5b;
      outline: none;
      text-align: center;
      .el-input__inner {
        width: 366px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 19px;
        color: #fff;
        border: 1px solid #464c5b;
        outline: none;
        text-align: center;
      }
    }

    .handle {
      display: flex;
      align-items: center;
      button {
        &:first-child {
          width: 98px;
          height: 32px;
          color: #fff;
          background: rgba(255, 255, 255, 0.3);
          margin-right: 8px;
        }
        &:last-child {
          width: 98px;
          height: 32px;
          background-color: #fe4d45;
          color: #fff;
        }
      }
    }
  }
  .headMove-enter {
    transform: translateY(-100%);
  }
  .headMove-enter-active {
    transition: all 1s;
  }
  .headMove-enter-to {
    transform: translateY(0);
  }
  #content {
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 60px);
  }
}
</style>

<style lang="scss">
.controlBarWrap {
  position: absolute;
  top: 50%;
  right: -80px;
  transform: translateY(-50%);
  width: 80px;
  height: 230px;
  background-image: url("../../../assets/images/control_bar_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  transition: all 0.5s;
  .controlList {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 0 0 10px 8px;
    height: 100%;
    .control {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding: 0 10px;
      border-bottom: 1px solid #f3f3f3;
      color: #666;
      cursor: pointer;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
